<template>
  <DomainInstructions />
</template>

<script>
import DomainInstructions from '@/components/Company/DomainInstructions.vue';

export default {
  name: 'InstructionsDomain',
  components: { DomainInstructions },
  metaInfo() {
    return {
      title: this.$t('pageInstructionDomain'),
    };
  },
  setup() {
    return {
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  pageInstructionDomain: Instructions for connecting the domain
</i18n>

<i18n locale="ru" lang="yaml">
  pageInstructionDomain: Инструкция по подключению домена
</i18n>
